import { configureStore } from "@reduxjs/toolkit";

import deviceReducer from "./Slices/deviceSlice";
import layoutReducer from "./Slices/layoutSlice";
import playlistReducer from "./Slices/playlistSlice";
import campaignReducer from "./Slices/campaignSlice";

import globalReducer from "./Slices/Global/globalSlice";
import appsReducer from "./Slices/Apps/appsSlice";
import scrollReducer from "./Slices/scrollSlice";
import popupScrollReducer from "./Slices/popupScrollSlice";
import matchSchedulerReducer from "./Slices/matchSchedulerSlice";
import adMarketplaceReducer from "./Slices/adMarketplaceSlice";
import smartAdSchedulerReducer from "./Slices/smartAdSchedulerSlice";


export const store = configureStore({
  reducer: {
    //  reducers will be here
    playlist: playlistReducer,
    campaign: campaignReducer,

    device: deviceReducer,
    global: globalReducer,
    layout: layoutReducer,
    scroll: scrollReducer,
    popupScroll: popupScrollReducer,

    apps: appsReducer,
    matchScheduler: matchSchedulerReducer,
    adMarketplace: adMarketplaceReducer,
    smartAdScheduler: smartAdSchedulerReducer,
  },
  devTools: true,
});
